import React, {ChangeEvent, useState, useRef} from 'react';
import {Box, VStack, Input, useTheme, Center, Button} from '@chakra-ui/react';
import {TextG14, TextG16, TextG24} from '../../components/typography';
import UserAvatar from '../../components/UserAvatar';
// @ts-ignore
import styled, {css} from 'styled-components';
import useAuth from '../../hooks/useAuth';
import Icon from '../../components/Icon';
import ProfilePicModal from '../Profile/Edit/ProfilePhotoModal';

const EditIconContainer = styled(Box)<{theme: any}>`
  background: white;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 5px;
  position: absolute;
  right: 5%;
  bottom: 4%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 1;
  ${(props: any) =>
    props.theme &&
    props.theme.colors &&
    css`
      border: 1px solid ${props.theme.colors.grey};
    `};
`;

const iconStyle: React.CSSProperties = {
  display: 'block',
  marginTop: '2px',
  textAlign: 'center',
  fontSize: '20px',
};

interface Intro9AvatarProps {
  onValidationChange: (isValid: boolean) => void;
}

const IntroAvatar = ({onValidationChange}: Intro9AvatarProps) => {
  const theme = useTheme();
  const {user} = useAuth();
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState<ChangeEvent<HTMLInputElement>>();
  const inputElement = useRef<HTMLInputElement | null>(null);
  const profilePhotoUrl = user?.profilePhotoUrl;

  const handleUpload = (upload: ChangeEvent<HTMLInputElement>) => setUploadedImage(upload);

  // Avatar step is always valid (optional)
  React.useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  return (
    <VStack
      flex={1}
      spacing={6}
      px={4}
      pt={4}
      pb={4}
      align="stretch"
      justify="flex-start"
      overflow="auto">
      {/* Title */}
      <Box>
        <TextG24 fontSize="26px" fontWeight="700" lineHeight="34px" color="#262626">
          Put a Face to
        </TextG24>
        <TextG24 fontSize="26px" fontWeight="700" lineHeight="34px" color="#C9136B">
          Your Name
        </TextG24>
      </Box>

      {/* Description */}
      <TextG14 lineHeight="22px" color="#636363" fontWeight="500">
        Upload a photo so people can recognize you at events and in chats. No pressure—if you skip, we'll just use your initials.
      </TextG14>

      {/* Avatar */}
      <Box
        mt={6}
        mb={4}
        position="relative"
        onClick={() => {
          if (!profilePhotoUrl && inputElement && inputElement.current) {
            inputElement.current.click();
          } else setShowPhotoModal(true);
        }}
        cursor="pointer">
        <Center>
          <Box w={48} h={48} pos="relative">
            <UserAvatar size="full" user={user} fontSize="10rem !important" />
            <EditIconContainer theme={theme}>
              <Icon style={iconStyle} iconName="fi-rr-camera" />
            </EditIconContainer>
          </Box>
        </Center>
      </Box>

      {/* Add Photo Button */}
      <Center>
        <Button style={{background: 'transparent', color: theme.colors.blue}}>
          <label htmlFor="image-file" style={{cursor: 'pointer'}}>
            <Input
              ref={inputElement}
              type="file"
              id="image-file"
              accept="image/*;capture=camera"
              onChange={handleUpload}
              hidden
            />
            <TextG16 style={{fontWeight: '400'}}>Add a Photo</TextG16>
          </label>
        </Button>
      </Center>

      <ProfilePicModal
        show={showPhotoModal}
        setShow={setShowPhotoModal}
        uploadedImage={uploadedImage}
      />
    </VStack>
  );
};

export default IntroAvatar;
